/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
  ValidationProblemDetails,
  WhitelabelSettingReadModel,
  WhitelabelSettingWriteModel,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
    WhitelabelSettingReadModelFromJSON,
    WhitelabelSettingReadModelToJSON,
    WhitelabelSettingWriteModelFromJSON,
    WhitelabelSettingWriteModelToJSON,
} from '../models/index';

export interface WhitelabelGetTranslationsRequest {
    languageCode: string;
}

export interface WhitelabelResetSettingToDefaultPutRequest {
    key: string;
}

export interface WhitelabelUpdateSettingPutRequest {
    whitelabelSettingWriteModel?: WhitelabelSettingWriteModel;
}

/**
 * 
 */
export class WhitelabelApi extends runtime.BaseAPI {

    /**
     */
    async whitelabelGetSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WhitelabelSettingReadModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Whitelabel/settings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WhitelabelSettingReadModelFromJSON));
    }

    /**
     */
    async whitelabelGetSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WhitelabelSettingReadModel>> {
        const response = await this.whitelabelGetSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async whitelabelGetTranslationsRaw(requestParameters: WhitelabelGetTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling whitelabelGetTranslations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Whitelabel/translations.{languageCode}.json`;
        urlPath = urlPath.replace(`{${"languageCode"}}`, encodeURIComponent(String(requestParameters['languageCode'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async whitelabelGetTranslations(requestParameters: WhitelabelGetTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.whitelabelGetTranslationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async whitelabelResetAllSettingsToDefaultPutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Whitelabel/settings/reset-all`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async whitelabelResetAllSettingsToDefaultPut(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.whitelabelResetAllSettingsToDefaultPutRaw(initOverrides);
    }

    /**
     */
    async whitelabelResetSettingToDefaultPutRaw(requestParameters: WhitelabelResetSettingToDefaultPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling whitelabelResetSettingToDefaultPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Whitelabel/settings/reset/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async whitelabelResetSettingToDefaultPut(requestParameters: WhitelabelResetSettingToDefaultPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.whitelabelResetSettingToDefaultPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async whitelabelUpdateSettingPutRaw(requestParameters: WhitelabelUpdateSettingPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/Whitelabel/settings`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WhitelabelSettingWriteModelToJSON(requestParameters['whitelabelSettingWriteModel']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async whitelabelUpdateSettingPut(requestParameters: WhitelabelUpdateSettingPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.whitelabelUpdateSettingPutRaw(requestParameters, initOverrides);
    }

}
